import React from 'react';
import { Box, Typography } from '@mui/material';
import zeplinColor from 'theme/Color';

type CityData = {
  label: string;
  percentage: number;
  multiplier: number;
};

const TopCitiesChart = ({
  cities,
  setTabValue,
  value,
}: {
  cities: CityData[];
  setTabValue: React.Dispatch<React.SetStateAction<number>>;
  value: any;
}) => {
  const maxPercentage = Math.max(...cities.map((c) => c.percentage));

  return (
    <Box
      sx={{
        borderRadius: '14px',
        padding: { xs: '12px 16px', xl: '16px' },
        border: `1px solid ${zeplinColor.Neutral5}`,
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant='responsiveHeading3'>Top Cities</Typography>
        <Typography
          variant='responsiveButtonSmall'
          color={zeplinColor.Brand1}
          sx={{ cursor: 'pointer' }}
          onClick={() => setTabValue(2)}
        >
          View All
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        {cities.map((city, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
            }}
          >
            <Typography variant='responsiveBody3' sx={{ minWidth: '120px', fontWeight: 500 }}>
              {city?.label}
            </Typography>

            <Typography
              variant='responsiveBody3'
              sx={{ minWidth: '50px', color: zeplinColor.BasicBlack }}
            >
              {city?.percentage}%
            </Typography>

            <Box
              sx={{
                flex: 1,
                height: '24px',
                backgroundColor: zeplinColor.Neutral3,
                borderRadius: '6px',
                position: 'relative',
                overflow: 'hidden',
                width: '441px',
              }}
            >
              <Box
                sx={{
                  width: `${(city.percentage / maxPercentage) * 441}px`,
                  height: '100%',
                  background: '#F3A03F',
                  borderRadius: '6px',
                  transition: 'width 0.3s ease',
                }}
              />
            </Box>

            <Typography
              variant='responsiveBody3'
              sx={{ minWidth: '50px', color: zeplinColor.BasicBlack, textAlign: 'right' }}
            >
              {city?.multiplier?.toFixed(1)}x
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TopCitiesChart;
